import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { makeBackendApi } from 'services/BackendApi/BackendApi';
import { IInternalUsersFilter, ITravelAgentResponse } from 'services/BackendApi';
import { IPagination } from 'store/common/types';

export const useInternalUsers = (filter: IInternalUsersFilter, pagination: IPagination = { offset: 0, limit: 1000 }): UseQueryResult<{ data: ITravelAgentResponse }, Error> => {
  const backendApi = makeBackendApi();

  return useQuery({
    queryKey: ['internal-users', filter, pagination],
    queryFn: () =>
      backendApi.getInternalUsersList(
        filter,
        pagination
      ),
  });
};
